// extracted by mini-css-extract-plugin
export var footer = "_nh-5";
export var fulfillmentInput = "_nh-0";
export var shipDateInput = "_nh-1";
export var shipmentModal = "_nh-2";
export var shipmentModalContent = "_nh-3";
export var tableContainer = "_nh-4";